module.exports = __webpack_public_path__ + "media/img/illustrations/happiness-ef8d9cfd01d3ffb181d9f55623c52a0a.svg";